import data from './data'
import methods from './methods'
import mounted from './mounted'
import validations from './validations'

export default {
  data,
  methods,
  mounted,
  validations
}



// WEBPACK FOOTER //
// ./src/app/auth/reset/resources/index.js